import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import SearchField from "./SearchField.js";
import FormControl from "@material-ui/core/FormControl";

const styles = theme => ({
    formControl: {
        width: "100%",
    }
});

class SearchFields extends Component {

    onFormSubmit = e => {
        // Prevent the form from actually submitting
        e.preventDefault();
        this.props.handleSearch(1);
    }

    render() {

        const {classes,
            handleSearch,
            handleSearchFieldChange,
            handleSortFieldChange,
            searchFields,
            searchFieldsError
        } = this.props;

        let errorMessage = (searchFieldsError) ?
            <Typography variant='body2' align='center'>Error: {searchFieldsError.message}</Typography> :
            null;

        let sortFields = searchFields.fields.some(x => x.sortable) ?
            <Grid item xs={12}>
                <Typography variant='body1'>
                    Sort by:<br/>
                    {
                        searchFields.fields.filter(x => x.sortable && !x.hideField).map((element, index) => {
                            let buttonStyle = (element.isBeingSorted) ? "primary" : "default";
                            return (
                                <Button key={index} style={{margin: "5px"}} onClick={() => {
                                    handleSortFieldChange(element.filterId)
                                }} variant="contained" size="small"
                                        color={buttonStyle}>{element.label}</Button>
                            )
                        })
                    }
                </Typography>
            </Grid> :
            null;

        if (searchFields.fields) {
            return (
                <Paper style={{padding: "10px"}}>
                    {errorMessage}
                    <form onSubmit={this.onFormSubmit}>
                    <Typography variant='h5' align='center'>{searchFields.categoryName}</Typography>
                    <Grid container spacing={24}>
                        {
                            searchFields.fields.filter(x => (!x.hideField && x.fieldType != "sortonly")).map((element, index) => {
                                return (
                                    <Grid key={index} item md={3} sm={4} xs={12}>
                                        <SearchField classes={classes} field={element}
                                                     handleSearchFieldChange={handleSearchFieldChange}></SearchField>
                                    </Grid>
                                );
                            })
                        }
                        <Grid item md={3} sm={4} xs={12}>
                            <Button type={"submit"} variant="contained" size="large" color="primary">Search</Button>
                        </Grid>
                        {sortFields}
                    </Grid>
                    </form>
                </Paper>);
        }
        return ("");
    }
}

export default withStyles(styles)(SearchFields);

